<template>
  <div>
    <!-- <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper> -->
    <div class="register">
      <Row :gutter="10" class="top">
        <Col span="24">
        <div class="title">全国药品交易会 展商报名/PHARMCHINA - Booth Application</div>
        </Col>
        <!-- <Col span="8" class="f-tar">
        <Button shape="circle" style="margin-left:10px" @click="$router.push(`/ex-register-en/register-mobile`)">English</Button>
        </Col> -->
      </Row>
      <registerForm ref="registerForm"></registerForm>
      <registerAddr ref="registerAddr"></registerAddr>

      <div class="register-box">
        <!-- 展会联系人信息   -->
        <div class="top-title">
          <div class="line"></div>
          注册费
        </div>
        <div class="tip-info">
          <p>1.会刊费、展商胸卡（含税）：580元</p>
          <p>2.立春小程序-企业专属店铺（含税）：乙方可在立春小程序线上平台开通企业账号，享有店铺搭建、产品展示、询盘管理功能权限。920元</p>
        </div>
        <div class="tip">
          最终展位费=展位费+注册费
        </div>
      </div>
      <div class="remark">
        <span>备注/Notes：</span><Input v-model="remark" maxlength="80" show-word-limit type="textarea" :rows="4"
          placeholder="请简要输入您对展位的要求" />
      </div>


      <div class="basic register-entrance" style="margin-top: 80px" v-if="sectionLists.length > 0">
        <div class="basic-header">
          <p>- 活动报名 -</p>
        </div>

        <div class="choice" style='padding: 10px;'>
          <Row :gutter="40">
            <Col span="24">
            <div class="select-box group1">
              <div class="select-content">
                <div class="form-item width-95" v-for="(section, index) in sectionLists">
                  <Form label-position="top" :ref="'formValidate' + index" :model="section" :rules="rulesValidate">
                    <FormItem label="" class="width-24" prop="title">
                      <Checkbox v-model="section.isCheck"></Checkbox><span style="color: #d9001b; cursor: pointer"
                        @click="checkNameClick(section)">{{ section.name }}</span>
                    </FormItem>
                    <FormItem label="联系人" class="width-24" prop="linkName" v-if='section.isCheck'>
                      <Input v-model="section.linkName" placeholder="请输入联系人"></Input>
                    </FormItem>
                    <FormItem label="联系电话" class="width-24" prop="linkTel" v-if='section.isCheck'>
                      <Input v-model="section.linkTel" placeholder="请输入联系电话"></Input>
                    </FormItem>

                    <FormItem label="邮箱" class="width-24" prop="" v-if='section.isCheck'>
                      <Input v-model="section.linkEmail" placeholder="请输入邮箱"></Input>
                    </FormItem>
                    <FormItem label="部门" class="width-24" prop="" v-if='section.isCheck'>
                      <Input v-model="section.linkDepartment" placeholder="请输入部门"></Input>
                    </FormItem>
                    <FormItem label="职务" class="width-24" prop="" v-if='section.isCheck'>
                      <Input v-model="section.linkJobTitle" placeholder="请输入职务"></Input>
                    </FormItem>
                  </Form>
                </div>
              </div>
            </div>
            </Col>
          </Row>
        </div>
      </div>



      <div class="f-tac submit-btn">
        <Button type="primary" size="large" long @click="handleSubmit" :loading="loading">Confirm and
          submit</br>确认以上信息，并提交展位申请
        </Button>
      </div>

    </div>
  </div>
</template>

<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import { mapActions } from "vuex";
import registerForm from "./components/mobile-register-form.vue";
import registerAddr from "./components/mobile-register-addr.vue";
export default {
  name: 'register',
  components: {
    registerForm,
    registerAddr,
    gSwiper,
  },
  data() {
    let that = this;
    const linkMobValid = (rule, value, callback) => {
      if (/^[1][0-9]{10}$/.test(value)) {
        callback();
      } else {
        callback("请输入正确的联系电话");
      }
    };
    return {
      remark: '',
      loading: false,
      arr: [{ id: 1, path: require('../../../assets/img/banner.jpg') }],

      sectionLists: [],

      rulesValidate: {
        linkName: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        linkTel: [{ required: true, validator: linkMobValid, trigger: "blur" }],
      },
    };
  },

  computed: {
    option() {
      return {
        exhibitionId: "57D57E6B-E417-4B44-90F7-A855C96886AD",
        pageSize: 999,
        pageIndex: 1,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "",
                  Value: "",
                },
              },
            ],
          },
        },
      };
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
      PCActivityPage: "hostSetModule/PCActivityPage",
      PCActivityUpdateRegCount: "hostSetModule/PCActivityUpdateRegCount", //修改活动注册数量

    }),

    async activityWay() {
      let arr = [];
      this.sectionLists.forEach((item, index) => {
        let form = "formValidate" + index;
        this.$refs[form][0].validate((valid) => {
          if (valid) {
            arr.push(true);
          } else {
            arr.push(false);
          }
        });
      });
      let flag = arr.every((item) => {
        return item === true;
      });
      if (flag) {
        //全部为true,验证通过
        //验证通过
        // this.$Message.success("通过");
        return Promise.resolve({ valid: true });
      } else {
        // this.$Message.error("信息填写有误");
        return Promise.resolve({ valid: false });
      }
    },

    async handleSubmit() {
      //   console.log( sessionStorage.getItem('exhibitionSelectId'),);
      // debugger
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerAddr.validHandle();
      this.loading = false;
      if (!res2.valid) return;
      console.log('registerForm', res);
      console.log('registerAddr', res2);

      let res3 = await this.activityWay();
      if (!res3.valid) return;
      let actList = [];
      let Ids = [];
      let actData = {};
      this.sectionLists.forEach((item, index) => {
        if (item.isCheck) {
          actData.pcActivityId = item.id;
          actData.applyCompanyId = "00000000-0000-0000-0000-000000000000";
          actData.exhibitionId = item.exhibitionId;
          actData.linkName = item.linkName;
          actData.linkTel = item.linkTel;
          actData.linkEmail = item.linkEmail;
          actData.linkDepartment = item.linkDepartment;
          actData.linkJobTitle = item.linkJobTitle;
          actList.push(actData);
          Ids.push(item.id);
          actData = {};
        }
      });
      console.log(actList);


      let opt = {
        newCompany: { ...res.form, isNeedUpdate: res2.isNeedUpdate, isNeedAngular: res2.isNeedAngular },
        lists: [{
          //   exhibitionId: '57D57E6B-E417-4B44-90F7-A855C96886AD',
          exhibitionId: sessionStorage.getItem('exhibitionSelectId'),
          ...res2.ApplyCompanyOrderNewDto,
          remark: this.remark
        }],
        activites: actList,
        reportType: 'cn'
      };
      console.log('option', opt);
      let bool = await this.getApplyCompanyRoastCreate(opt);
      let count = await this.PCActivityUpdateRegCount({ activityIds: Ids });
      this.loading = false;
      console.log('getApplyCompanyRoastCreate', bool);
      if (bool && bool.successed) {
        let query =
          "company=" +
          encodeURI(res.form.companyName) +
          "&exname=" +
          encodeURI(res2.exhibition.name) +
          "&exstartTime=" +
          encodeURI(res2.exhibition.startTime) +
          "&exendTime=" +
          encodeURI(res2.exhibition.endTime) +
          "&excity=" +
          encodeURI(res2.exhibition.city) +
          "&exareaName=" +
          encodeURI(res2.ApplyCompanyOrderNewDto.areaName) +
          "&exareaType=" +
          encodeURI(res2.ApplyCompanyOrderNewDto.areaType) +
          "&exshowArea=" +
          encodeURI(res2.ApplyCompanyOrderNewDto.showArea);
        this.$router.push(`/ex-register/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "提交失败，请重新尝试！";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }

    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },

    async init() {
      let list = await this.PCActivityPage(this.option);
      if (list && list.items.length > 0) {
        list.items.map((e) => {
          e.isCheck = false;
          e.linkName = "";
          e.linkTel = "";
          e.linkEmail = "";
          e.linkDepartment = "";
          e.linkJobTitle = "";
        });
        this.sectionLists = list.items;
        console.log(this.sectionLists, "sectionLists0000000");
      }
    },

    checkNameClick(e) {
      console.log(e);
      if (e.type == "textArea") {
        this.$router.push({ path: '/ex-register/register-detail', query: { html: e.content } });
      }
      if (e.type == "url") {
        window.open(e.url, '_blank');
      }
    },

  },
  created() {
    if (this.IsPC()) {
      this.$router.push(`/ex-register/register`);
    }
    document.title = "全国药品交易会参展报名/PHARMCHINA - Booth Application";
  },
}

</script>

<style lang="scss" scoped>
.basic {
  background-color: #ffff;

  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #d00300 !important;
    }

    .van-switch--on,
    .ivu-radio-inner:after {
      background-color: #d00300;
    }

    .van-button--info,
    .van-radio__icon--checked .van-icon,
    .ivu-switch-checked {
      border-color: #d00300;
      background-color: #d00300;
    }

    .ivu-input {
      border: none;
    }

  }

  &-header {
    width: 100%;
    height: 48px;
    background-color: #d00300;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 48px;
      font-size: 15px;
    }

    span {
      width: 30px;
      height: 15px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-phone {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-license {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  .upload-btn {
    width: 105px;
    height: 105px;
    border: dotted 1px #bfbfbf;
    text-align: center;
    margin: 10px 16px;
    border-radius: 4px;

    img {
      display: inline-block;
      width: 25px;
      height: 25px;
      margin-top: 20px;
      margin-bottom: 10px;
    }

    div {
      font-size: 12px;
      color: #999;
    }
  }

  .license-img {
    display: flex;
    flex-wrap: wrap;

    &-list {
      line-height: 32px;
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;

      span {
        color: #d00300;
        cursor: pointer;
      }

      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-leader {
    padding: 0 30px;
    background-color: #ededed;
    position: relative;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }

    .above {
      position: absolute;
      left: 240px;
      top: 10px;
    }
  }

  &-leaders {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;

    .ivu-checkbox-wrapper {
      margin: 0;
    }

    span {
      color: #ff0000;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }
}

.register {
  max-width: 1200px;
  margin: 0 auto;
  background: #f7f7f7;

  .top {
    padding: 15px;
  }

  .title {
    font-size: 15px;
    color: #d00300;
    font-weight: bold;
    line-height: 32px;
  }
}

.submit-btn {
  text-align: center;
  padding: 5px 15px 0;

  button {
    background-color: #d00300;
    font-size: 15px;
    border-color: #d00300;
    margin-bottom: 30px;
    height: 60px;
    color: #fff;
  }
}

.tip-info {
  margin: 25px auto 15px auto;
  padding: 0 15px;
  white-space: nowrap;
  color: #666;

  p {
    font-size: 13px;
    margin-bottom: 4px;
    white-space: normal;
  }
}

.register-box {
  background: #fff;
  padding-bottom: 30px;
  margin-bottom: 30px;

  .tip {
    font-size: 15px;
    line-height: 24px;
    color: #f00;
    padding-left: 15px;
    font-weight: 500;
  }
}

.top-title {
  line-height: 50px;
  align-items: center;
  padding-left: 15px;
  font-size: 13px;
  color: #333;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;

  .line {
    content: "";
    width: 3px;
    height: 15px;
    background-color: #d00300;
    margin-right: 7px;
  }

  span {
    font-size: 15px;
    color: #f00;
  }

  &-left {
    flex: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}

.remark {
  padding: 0 15px;
  margin-bottom: 40px;

  span {
    font-size: 13px;
    color: #333;
    height: 30px;
    display: block;
  }
}
</style>
